import { useState } from "react";
import { useNotifications } from "../../hooks/useNotifications";
import { NotificationCenter } from "./NotificationCenter";

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { unreadCount } = useNotifications();

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={
          unreadCount > 0
            ? `Notifications, ${unreadCount} unread`
            : "Notifications"
        }
        className="relative p-2 rounded-full hover:bg-bg-surface text-text-secondary"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          aria-hidden
        >
          <path
            d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10 21a2 2 0 0 0 4 0" strokeLinecap="round" />
        </svg>
        {unreadCount > 0 ? (
          <span
            aria-hidden
            className="absolute top-1 right-1 w-2 h-2 rounded-full bg-accent-fg"
          />
        ) : null}
      </button>
      {open ? <NotificationCenter onClose={() => setOpen(false)} /> : null}
    </div>
  );
}
